import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = ["value", "required", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(['block', $setup.wrapperClass])
  }, [
    ($props.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString($props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("textarea", _mergeProps({
      value: $props.modelValue,
      required: $props.required,
      placeholder: $props.placeholder,
      class: "field-area"
    }, $setup.textareaAttrs, {
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onInput && $setup.onInput(...args)))
    }), null, 16, _hoisted_2)
  ], 2))
}